import React from 'react';
import {
    Col, Row, Modal, FormControl, FormGroup, ControlLabel, Form
} from 'react-bootstrap';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ColorPicker from '../Components/ColorPicker.jsx';
import Checkbox from '../../elements/CustomCheckbox/CustomCheckbox.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalCalendario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventtextcolor: this.props.calendario ? this.props.calendario.eventtextcolor : '#f2f3f4' ,
      eventbackgroundcolor: this.props.calendario ? this.props.calendario.eventbackgroundcolor : '#EB144C',
      nombre: this.props.calendario ? this.props.calendario.nombre : '',
      publico: this.props.calendario ? this.props.calendario.publico : false,
      checked: this.props.calendario ? this.props.calendario.checked : false,
      userid: this.props.userId,
      id: this.props.calendario ? this.props.calendario.id : null,
      errorNombre: false,
    };
    this.save = this.save.bind(this);
  }

  save() {
    const calendar = {
      eventtextcolor: this.state.eventtextcolor ,
      eventbackgroundcolor: this.state.eventbackgroundcolor ,
      nombre: this.state.nombre ,
      publico: this.state.publico ? 1 : 0,
      checked: this.state.checked ? 1 : 0,
      userid: this.state.userid ,
      id: this.state.id ,
    };

    const error = !calendar.nombre || calendar.nombre === '';

    if (!error) {
      this.props.saveCalendar(calendar);
    } else {
      this.setState({errorNombre: true})
      this.props.errorAlert(
        <div>
          Ingrese un nombre para el calendario!
        </div>);
    }
  }

  render() {

    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>{this.props.calendario ? 'Editar Calendario' : 'Crear calendario'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={12}>
                    <Form>
                      <FormGroup validationState={this.state.errorNombre ? 'error': null}>
                        <ControlLabel>{'Nombre'} </ControlLabel>
                        <FormControl
                          type="text" value={this.state.nombre ? this.state.nombre : ''}
                          onChange={(e) => this.setState({nombre: e.target.value, errorNombre: false})}
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{'Color del Texto'}
                      </ControlLabel>
                      <ColorPicker
                        onChangeColor={(color) => {this.setState({eventtextcolor: color})}}
                        initialColor={this.state.eventtextcolor}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{'Color del Fondo'}
                      </ControlLabel>
                      <ColorPicker
                        onChangeColor={(color) => {this.setState({eventbackgroundcolor: color})}}
                        initialColor={this.state.eventbackgroundcolor}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <Checkbox
                      label={'Calendario Público'}
                      number={'mentor'}
                      isChecked={this.state.publico}
                      handleOnChange={(e) => this.setState({ publico: e })}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.closeModal}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={() => this.save()}
                >
                  Guardar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalCalendario;



// WEBPACK FOOTER //
// ./src/views/Calendar/ModalCalendario.jsx